import { render } from "./CadastroConsumidor.vue?vue&type=template&id=30c2e6d7&scoped=true"
import script from "./CadastroConsumidor.vue?vue&type=script&lang=js"
export * from "./CadastroConsumidor.vue?vue&type=script&lang=js"

import "./CadastroConsumidor.vue?vue&type=style&index=0&id=30c2e6d7&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c2e6d7"]])

export default __exports__